import { DfcSurface, getDfcSurface } from '../Utils/dfcSurface';
import { useContext, useMemo } from 'react';
import { useDfcThemeMode } from '../context/DfcThemeModeContext';
import { CheckoutContext, CheckoutContextProps } from '../context/CheckoutContext';
import { ASA_SURFACE, isAsaCompany } from '../Utils/asaBrand';
import { CLUB15_SURFACE, isClub15Company } from '../Utils/club15Brand';

/**
 * The one way a DFC village component obtains its `DfcSurface` token scale.
 * Resolves the current light/dark mode from `DfcThemeModeContext`, and All Sports Arena's
 * overrides when the company is ASA.
 */
const useDfcSurface = (): DfcSurface => {
  const { mode } = useDfcThemeMode();
  const { company } = useContext(CheckoutContext) as CheckoutContextProps;
  const isAsa = isAsaCompany(company);
  const isClub15 = isClub15Company(company);
  // All Sports Arena: royal-blue buttons and selected states (`ASA_SURFACE`). Club 15: cream,
  // charcoal and coral (`CLUB15_SURFACE`). DFC's is unchanged.
  return useMemo(
    () =>
      isAsa
        ? { ...getDfcSurface(mode), ...ASA_SURFACE[mode] }
        : isClub15
          ? { ...getDfcSurface(mode), ...CLUB15_SURFACE[mode] }
          : getDfcSurface(mode),
    [isAsa, isClub15, mode]
  );
};

export default useDfcSurface;
